export const secondsToText = (
  seconds: number,
  format: 'hh:mm:ss' | 'hh:mm' | 'mm:ss' | 'ss' = 'hh:mm'
) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  switch (format) {
    case 'hh:mm:ss':
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    case 'hh:mm':
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}`;
    case 'mm:ss': {
      const totalMinutes = Math.floor(seconds / 60);
      return `${totalMinutes.toString().padStart(2, '0')}:${secs
        .toString()
        .padStart(2, '0')}`;
    }
    case 'ss':
      return secs.toString();
    default:
      return '';
  }
};

export const timeToSec = (time: string) => {
  const hourSplited = time.split(':');
  const hour = Number(hourSplited?.[0]);
  const min = Number(hourSplited?.[1]);
  const sec = Number(hourSplited?.[2]);

  const finalHours = hour ? hour * 60 * 60 : 0;
  const finalMin = min ? min * 60 : 0;
  const finalSec = sec || 0;

  return finalHours + finalMin + finalSec;
};

export const getLastDayInMonth = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
